// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import notificationTableData from "layouts/manageNotifications/data/notificationTableData";
import add from "assets/images/add.png";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import WarnModal from "components/DeleteModal";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useAllNotificationsMutation } from "services/notifications";
import ShowToast from "components/MDToast";
import Pagination from "components/Pagination";
import moment from "moment";
import { useAddNotificationsMutation } from "services/notifications";
import { isString } from "utils/validations";
import { useDeleteNotificationMutation } from "services/notifications";
import Loader from "helpers/constants/Loader";
import useTranslation from "hooks/Translation";

const ManageNotifications = () => {
  const t = useTranslation();
  const [allNotification] = useAllNotificationsMutation();
  const [addNotification] = useAddNotificationsMutation();
  const [deleteNotification] = useDeleteNotificationMutation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const totalPages = Math.ceil(totalRecords / limit);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [error, setError] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAdd = async () => {
    if (!title) {
      return;
    }

    if (!message) {
      return;
    }

    if (!selectedType) {
      return;
    }

    const body = {
      notification_title: title,
      notification_message: message,
      notification_type: Number(selectedType),
      notification_for: 2,
    };

    try {
      const response = await addNotification(body).unwrap();
      if (response?.status === 200) {
        ShowToast("Notification sent successfully", "success");
        setOpenAddModal(false);
        getAllNotifications();
      } else {
        ShowToast("Please try again", "error");
      }
    } catch {
      ShowToast("Something went wrong", "error");
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteNotification({ id }).unwrap();
      if (response?.status === 200) {
        ShowToast("Notification Deleted Successfully", "success");
        setOpen(false);
        getAllNotifications();
      } else {
        ShowToast("Please try again", "error");
      }
    } catch {
      ShowToast("Something went wrong", "error");
    }
  };

  const getAllNotifications = async (page) => {
    let body = {
      start: page,
      length: 10,
      search: "",
    };
    setLoading(true);

    try {
      const response = await allNotification(body).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setNotificationData(response?.data?.response_object);
        setTotalRecords(response?.data?.total_records);
        // setTotalRecords(response?.data?.count);
      } else {
        setLoading(false);
        setNotificationData([]);
      }
    } catch (error) {
      setLoading(false);
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const Author = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox lineHeight={1}>
        <MDTypography display="block" variant="caption" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const columns = [
    { Header: "Title", accessor: "author", align: "left" },
    { Header: "Description", accessor: "price", align: "left" },
    { Header: "Date", accessor: "status", align: "left" },

    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = notificationData?.map((item) => ({
    author: <Author name={item?.title || "-"} />,
    price: <Job title={item?.message || "-"} />,
    status: <Job title={moment(item?.created_at).format("MM/DD/YYYY")} />,

    action: (
      <Box className="table_actions">
        <IconButton
          size="small"
          onClick={() => {
            setOpen(true);
            setSelectedId(item?.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    ),
  }));

  const handleClose = () => {
    setOpenAddModal(false);
    // formik.setFieldError("message", "");
  };

  useEffect(() => {
    getAllNotifications(page);
  }, [page]);

  return (
    <DashboardLayout>
      <Loader loading={loading} />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                // variant="gradient"
                bgColor="theme-1"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white">
                  {t.main.notificationTable}
                </MDTypography>
                <div
                  onClick={() => setOpenAddModal(true)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <MDTypography
                    sx={{
                      textDecoration: "underline", // Adds an underline
                      paddingRight: 1,
                    }}
                    variant="h6"
                    color="white"
                  >
                    {t.main.addNotification}
                  </MDTypography>
                  <img src={add} style={{ width: 20, height: 20 }} />
                </div>
              </MDBox>
              <MDBox pt={3}>
                {notificationData?.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  ""
                )}
              </MDBox>
              {notificationData?.length > 0 && (
                <MDBox p={2}>
                  <Pagination
                    setPage={setPage}
                    module={notificationData}
                    page={page}
                    onPageChange={setPage}
                    totalPages={totalPages}
                    limit={limit}
                    setLimit={setLimit}
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog
        open={openAddModal}
        onClose={handleClose}
        className="notification_dialog"
      >
        <DialogContent>
          <MDTypography variant="h5" fontWeight="medium" color="black" mb={1}>
            {t.main.sendNotification}
          </MDTypography>

          <form style={{ width: 400 }}>
            <FormControl fullWidth>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <MDBox mb={1}>
                    <MDTypography variant="subtitle2" className="custom_label">
                      {t.main.title}
                    </MDTypography>
                    <MDInput
                      type="text"
                      placeholder={t.main.title}
                      variant="outlined"
                      fullWidth
                      onChange={(val) => {
                        if (isString(val.target.value)) {
                          setTitle(val.target.value);
                        }
                      }}
                      value={title}
                      error={error && !title}
                    />
                  </MDBox>
                </Grid>
              </Grid>

              <MDBox mb={1}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.description}
                </MDTypography>
                <MDInput
                  type="text"
                  placeholder={t.main.description}
                  variant="outlined"
                  fullWidth
                  onChange={(val) => {
                    if (isString(val.target.value)) {
                      setMessage(val.target.value);
                    }
                  }}
                  value={message}
                  error={error && !message}
                />
              </MDBox>

              <MDBox mb={2}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.notificationType}
                </MDTypography>
                <FormControl fullWidth>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    displayEmpty
                    value={selectedType}
                    onChange={(val) => setSelectedType(val?.target?.value)}
                    sx={{
                      border:
                        error && !selectedType
                          ? "1px solid red"
                          : "1px solid grey", // Add a custom border color
                      borderRadius: "6px", // Optional: Add border radius for styling
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Adjust border color for the outlined variant
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color when focused
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t.main.select}
                    </MenuItem>

                    <MenuItem
                      value={"1"}
                      sx={{ color: "black", fontWeight: 500 }}
                    >
                      {t.main.broadcast}
                    </MenuItem>
                    <MenuItem
                      value={"2"}
                      sx={{ color: "black", fontWeight: 500 }}
                    >
                      {t.main.broadcast}
                    </MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
            </FormControl>
            <Box className="form_btn">
              <MDButton
                onClick={handleClose}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.cancel}
              </MDButton>
              <MDButton
                onClick={() => {
                  handleAdd();
                  setError(true);
                }}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.send}
              </MDButton>
            </Box>
          </form>
        </DialogContent>
      </Dialog>
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDelete(selectedId)}
        name="Notification"
      />
    </DashboardLayout>
  );
};

export default ManageNotifications;
